module.exports = __webpack_public_path__ + "img/ico_bx.cf6d4eaf.png";